namespace $ {
	export class $my_habrcomment_comment extends $mol_list {
		
		/**
		 * ```tree
		 * minimal_width 300
		 * ```
		 */
		minimal_width() {
			return 300
		}
		
		/**
		 * ```tree
		 * time $mol_time_moment
		 * ```
		 */
		@ $mol_mem
		time() {
			const obj = new this.$.$mol_time_moment()
			
			return obj
		}
		
		/**
		 * ```tree
		 * expandable false
		 * ```
		 */
		expandable() {
			return false
		}
		
		/**
		 * ```tree
		 * rows /
		 * 	<= Head
		 * 	<= Message
		 * 	<= Replies
		 * ```
		 */
		rows() {
			return [
				this.Head(),
				this.Message(),
				this.Replies()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * expanded?val true
		 * ```
		 */
		@ $mol_mem
		expanded(val?: any) {
			if ( val !== undefined ) return val as never
			return true
		}
		
		/**
		 * ```tree
		 * Expand $mol_check_expand
		 * 	hint \Разворачивание ветки
		 * 	checked?val <=> expanded?val
		 * ```
		 */
		@ $mol_mem
		Expand() {
			const obj = new this.$.$mol_check_expand()
			
			obj.hint = () => "Разворачивание ветки"
			obj.checked = (val?: any) => this.expanded(val)
			
			return obj
		}
		
		/**
		 * ```tree
		 * user_link \
		 * ```
		 */
		user_link() {
			return ""
		}
		
		/**
		 * ```tree
		 * user_avatar \
		 * ```
		 */
		user_avatar() {
			return ""
		}
		
		/**
		 * ```tree
		 * User_avatar $mol_image
		 * 	title \
		 * 	uri <= user_avatar
		 * ```
		 */
		@ $mol_mem
		User_avatar() {
			const obj = new this.$.$mol_image()
			
			obj.title = () => ""
			obj.uri = () => this.user_avatar()
			
			return obj
		}
		
		/**
		 * ```tree
		 * search \
		 * ```
		 */
		search() {
			return ""
		}
		
		/**
		 * ```tree
		 * user_name \
		 * ```
		 */
		user_name() {
			return " "
		}
		
		/**
		 * ```tree
		 * User_name $mol_dimmer
		 * 	needle <= search
		 * 	haystack <= user_name
		 * ```
		 */
		@ $mol_mem
		User_name() {
			const obj = new this.$.$mol_dimmer()
			
			obj.needle = () => this.search()
			obj.haystack = () => this.user_name()
			
			return obj
		}
		
		/**
		 * ```tree
		 * User_link $mol_link
		 * 	uri <= user_link
		 * 	sub /
		 * 		<= User_avatar
		 * 		<= User_name
		 * ```
		 */
		@ $mol_mem
		User_link() {
			const obj = new this.$.$mol_link()
			
			obj.uri = () => this.user_link()
			obj.sub = () => [
				this.User_avatar(),
				this.User_name()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * id \
		 * ```
		 */
		id() {
			return ""
		}
		
		/**
		 * ```tree
		 * time_string \
		 * ```
		 */
		time_string() {
			return ""
		}
		
		/**
		 * ```tree
		 * Time $mol_link
		 * 	arg * comment <= id
		 * 	sub / <= time_string
		 * ```
		 */
		@ $mol_mem
		Time() {
			const obj = new this.$.$mol_link()
			
			obj.arg = () => ({
				comment: this.id()
			})
			obj.sub = () => [
				this.time_string()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * head /
		 * 	<= Expand
		 * 	<= User_link
		 * 	<= Time
		 * ```
		 */
		head() {
			return [
				this.Expand(),
				this.User_link(),
				this.Time()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * Head $mol_view sub <= head
		 * ```
		 */
		@ $mol_mem
		Head() {
			const obj = new this.$.$mol_view()
			
			obj.sub = () => this.head()
			
			return obj
		}
		
		/**
		 * ```tree
		 * message \
		 * ```
		 */
		message() {
			return ""
		}
		
		/**
		 * ```tree
		 * image_uri* \
		 * ```
		 */
		image_uri(id: any) {
			return ""
		}
		
		/**
		 * ```tree
		 * Message $mol_html_view
		 * 	highlight <= search
		 * 	html <= message
		 * 	image_uri* <= image_uri*
		 * 	minimal_height 60
		 * ```
		 */
		@ $mol_mem
		Message() {
			const obj = new this.$.$mol_html_view()
			
			obj.highlight = () => this.search()
			obj.html = () => this.message()
			obj.image_uri = (id: any) => this.image_uri(id)
			obj.minimal_height = () => 60
			
			return obj
		}
		
		/**
		 * ```tree
		 * replies /$mol_view
		 * ```
		 */
		replies() {
			return [
			] as readonly $mol_view[]
		}
		
		/**
		 * ```tree
		 * Replies $mol_list rows <= replies
		 * ```
		 */
		@ $mol_mem
		Replies() {
			const obj = new this.$.$mol_list()
			
			obj.rows = () => this.replies()
			
			return obj
		}
	}
	
}

